import { render, staticRenderFns } from "./BJobsOpenings.vue?vue&type=template&id=318a41e6&scoped=true&"
import script from "./BJobsOpenings.vue?vue&type=script&lang=js&"
export * from "./BJobsOpenings.vue?vue&type=script&lang=js&"
import style0 from "./BJobsOpenings.vue?vue&type=style&index=0&id=318a41e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a41e6",
  null
  
)

export default component.exports